import React, { useState, useEffect } from 'react';

const LinearDashedBorder = () => {
  const [strokeDasharray, setStrokeDasharray] = useState('4.625,2.3125');

  useEffect(() => {
    const updateDashPattern = () => {
      const width = window.innerWidth;

      // Responsive dash patterns based on screen size
      if (width < 768) {
        setStrokeDasharray('8.25,4.312'); // Mobile - double (4.625*2, 2.3125*2)
      } else if (width < 1024) {
        setStrokeDasharray('6.25,2.312'); // Tablet - double (4.625*2, 2.3125*2)
      } else {
        setStrokeDasharray('4.625,2.3125'); // Large screens - original size
      }
    };

    // Set initial pattern
    updateDashPattern();

    // Update on window resize
    window.addEventListener('resize', updateDashPattern);

    return () => {
      window.removeEventListener('resize', updateDashPattern);
    };
  }, []);

  return (
    <svg
      width="100%"
      viewBox="0 0 1156 254.66668701171875"
      xmlns="http://www.w3.org/2000/svg"
      className="pointer-events-none absolute h-full"
      height="100%"
      preserveAspectRatio="none"
    >
      <defs>
        <linearGradient id="borderGradient">
          <stop offset="4.09%" stopColor="#7E77B3" />
          <stop offset="27.63%" stopColor="#8989FF" />
          <stop offset="51.07%" stopColor="#6C9DFF" />
          <stop offset="74.69%" stopColor="#78CFDA" />
          <stop offset="98.23%" stopColor="#9FF4A9" />
        </linearGradient>
      </defs>
      <rect
        x="1"
        y="1"
        width="1154"
        height="252.66668701171875"
        fill="transparent"
        stroke="url(#borderGradient)"
        strokeWidth="2"
        strokeDasharray={strokeDasharray}
      />
    </svg>
  );
};

export default LinearDashedBorder;
